const endpoint = "/api/account";

export const endpoints = {
  switchToUser: (userId) => `/api/login-as/${userId}`,
  getAccountUsers: `${endpoint}/users`,
  searchAccounts: `${endpoint}`,
  getAccount: (id) => `${endpoint}/${id}`,
  addRoleToAccount: `${endpoint}/roles`,
};
